<template>
  <div>Test Component</div>
</template>

<script>
export default {
  name: 'TestComponent'
};
</script>
